import { sanitizeTextForAnalytics } from "@/utils/helper"

export const addDataLayerVisualSearch = analytics => {
  const { adobeDataLayer: { getState } = {} } = window
  const page = getState && getState("page")
  if (page) {
    const { user, category, pageInfo } = page
    delete user["encodedEmailId"]
    delete user["profileType"]
    delete page["pageName"]
    delete page["pageUrl"]
    delete pageInfo["thumbnailImageUrl"]
    pageInfo["defaultImage"] = "n/a"
    pageInfo["imageId"] = "n/a"
    pageInfo["resourceType"] = "n/a"
    pageInfo["referrer"] = document.referrer
    category[
      "subCategory1"
    ] = `${category["pageType"]}:${category["productLocalCategory"]}`
  }
  const {
    eventKey,
    category,
    internalLinkZoneName = false,
    eventStatus,
    linkUrl,
    eventMsg,
    product,
  } = analytics
  const links = linkUrl ?? window.location.href
  const productRoom = page?.category?.room

  const evtAction = internalLinkZoneName ? `${eventKey}:${category}` : eventKey

  const eventInfo = {
    clickInternalLinks: "true",
    eventAction: `support:find a service part:kohler genuine service parts:${evtAction}`,
    eventMsg: eventMsg ? sanitizeTextForAnalytics(eventMsg) : "n/a",
    eventName: `support:find a service part:kohler genuine service parts:${evtAction}`,
    eventStatus: eventStatus ?? "n/a",
    eventType: "navigation",
    internalLinkName: internalLinkZoneName ? category : eventKey,
    internalLinkPosition: `support:find a service part${
      category ? `:${category}` : ""
    }`,
    internalLinkType:
      "support:find a service part:kohler genuine service parts",
    internalLinkURL: links,
    internalLinkZoneName: `support:find a service part:kohler genuine service parts${
      internalLinkZoneName || eventStatus ? `:${eventKey}` : ""
    }`,
  }
  const productInfo = product
    ? getAnalyticProductInfo(product, category, productRoom)
    : null

  window.adobeDataLayer.push({
    event: "cmp:click",
    page,
    eventInfo,
    ...(productInfo != null && { productInfo }),
  })
}

const getAnalyticProductInfo = (products, category, productRoom) => {
  const productInfo = {
    category: category,
    defaultImageName: products?.isoImageURL,
    description: sanitizeTextForAnalytics(products?.shortDescription),
    frequency: "n/a",
    globalDiscount: "n/a",
    globalOffer: "n/a",
    globalPromotionPrice: "n/a",
    isRecommended: "n/a",
    isSendNow: "n/a",
    isSubscription: "n/a",
    itemType: sanitizeTextForAnalytics(category),
    numberOfReviews: "n/a",
    pdpType: "regular finished goods",
    priceState: "regular price",
    productBasePrice: "n/a",
    productBrand: "kohler",
    productCategory: sanitizeTextForAnalytics(category),
    productCollectionsName: products?.name,
    productColor: "n/a",
    productCouponCode: "n/a",
    productCoupondiscount: "n/a",
    productFindingMethod: "n/a",
    productID: products?.sku,
    productName: sanitizeTextForAnalytics(products?.name),
    productPartnerBuyNow: "n/a",
    productRoom: productRoom,
    productSalePrice: "n/a",
    productSaleable: "n/a",
    productStatus: "n/a",
    productSuperSku: "n/a",
    productTileName: sanitizeTextForAnalytics(products?.shortDescription),
    quantity: "n/a",
    ratings: "n/a",
    waterSenseProduct: false,
  }
  return productInfo
}
